import { render, staticRenderFns } from "./Target.vue?vue&type=template&id=bfbf550a&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Target.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/Target.vue
// module id = 2448
// module chunks = 1